<template>
	<div style="min-height: 300px; height: 300px">
		<b-row>
			<b-col cols="6" xs="6" sm="6" md="5" lg="4" xl="4">
				<div class="sa-pianificazione-edit-container">
					<vc-calendar v-if="tipologia === 'DataMese'" :attributes="attributes" transition="fade" nav-visibility="hidden" @dayclick="onDayClick" />
				</div>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="7" lg="8" xl="8">
				<div class="sa-pianificazione-edit-container">
					<div style="display: flex; flex-direction: row">
						<div style="flex: 1">
							<b-row>
								<b-col cols="6" xs="12" sm="12" md="12" lg="12" xl="12">
									<b-row>
										<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
											<b-input-group class="mb-3">
												<b-form-radio v-model="tipologia" style="display: block; padding-bottom: 3px; width: 100%" name="some-radios" value="DataMese">Date del Mese (Selezionare i giorni dal Calendario):</b-form-radio>
												<!-- <label style="width: 100%" for="">Date del Mese (Selezionare i giorni dal Calendario):</label> -->
												<br />
												<b-form-input v-model="giorniSelezionati" readonly></b-form-input>
											</b-input-group>
										</b-col>
										<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
											<b-row>
												<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
													<b-input-group class="mb-3">
														<b-form-radio v-model="tipologia" style="display: block; padding-bottom: 3px; width: 100%" name="some-radios" value="GiornoMese">Giorni del Mese:</b-form-radio>
														<!-- <label style="width: 100%" for="">Giorni del Mese:</label> -->
														<br />
														<b-form-select :disabled="sltGiornoMese" v-model="dayWeek" :options="daysWeekOptions" value-field="code" text-field="day" @input="onInputDayWeek"></b-form-select>
													</b-input-group>
												</b-col>
												<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
													<b-input-group class="mb-3">
														<label style="width: 100%" for="">Frequenza:</label>
														<br />
														<b-form-select :disabled="sltGiornoMese" v-model="frequenzaDayWeek" :options="frequenzaDaysWeekOptions" value-field="code" text-field="text" @input="onInputFrequenzaDayWeek"></b-form-select>
													</b-input-group>
												</b-col>
											</b-row>
										</b-col>
										<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
											<div class="sa-pianificazione-edit-container">
												<label for="">Orari</label>
												<div style="display: flex; flex-direction: row">
													<div style="flex: 1">
														<b-input-group class="mb-3">
															<date-picker format="HH:mm" value-type="timestamp" v-model="oraSelezionata" :disabled-time="disbilitaOrePrecedenti" placeholder="HH:mm" :default-value="new Date()" :minute-step="15" type="time"></date-picker>
														</b-input-group>
													</div>
													<div>
														<b-button size="sm" variant="outline-success  pull-right" style="height: 29px" @click="onClickAggiungiOrario()">
															<i class="fas fa-plus"></i>
														</b-button>
													</div>
												</div>
												<label class="sa-label-data">Ora Programmata:</label>
												<div v-for="(ora, index) in hoursSelected" :key="index" style="display: flex; flex-direction: row" :class="getClass(index)">
													<div style="flex: 1; display: table">
														<span style="display: table-cell; vertical-align: middle; font-size: var(--label-font-size)">
															{{ ora }}
														</span>
													</div>
													<div>
														<b-button size="sm" variant="outline-danger outline-secondary pull-right " @click="onClickRemoveOrario(index)" :disabled="btnDisabledAggiungiOrario">
															<i class="far fa-trash-alt"></i>
														</b-button>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>
								</b-col>
								<b-col cols="6" xs="6" sm="12" md="12" lg="12" xl="12">
									<div class="sa-pianificazione-edit-container" style="height: 280px; overflow: auto; padding-bottom: 109px">
										<label class="sa-label-data">Elenco delle prossime {{ numeroElencoProgrammatoLbl }} attività programmate:</label>
										<div v-for="(attivita, index) in elencoAttivitaProgrammate" :key="index" style="display: flex; flex-direction: row" :class="getClass(index)">
											<div style="flex: 1; display: table">
												<span style="display: table-cell; vertical-align: middle; font-size: var(--label-font-size)"> {{ index + 1 }} - {{ attivita }} </span>
											</div>
										</div>
									</div>
								</b-col>
							</b-row>
						</div>
					</div>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";

export default {
	mixins: [UtilityMixin],
	components: { DatePicker },
	data() {
		const now = new Date();
		const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		const minDate = new Date(today);
		return {
			jsonDataSchedulazione: null,
			pianificazione: { giorni: null, orari: null, params: { tipologia: "DataMese", frequenza: null } },
			days: [],
			orarioDisabled: false,
			daysSelected: [],
			hoursSelected: [],
			btnDisabledAggiungiOrario: true,
			orarioRiferimento: null,
			giorniSelezionati: null,
			oraSelezionata: null,
			min: minDate,
			numeroElencoProgrammato: 10,
			numeroElencoProgrammatoLbl: 0,
			elencoAttivitaProgrammate: [],
			daysWeekOptions: [],
			dayWeek: null,
			tipologia: "DataMese",
			sltGiornoMese: true,
			frequenzaDaysWeekOptions: [
				{ code: null, text: "-Frequenza-" },
				{ code: 1, text: "Primo" },
				{ code: 2, text: "Secondo" },
				{ code: 3, text: "Terzo" },
				{ code: 4, text: "Quarto" },
				//{ code: 5, text: "Ultimo" },
			],
			frequenzaDayWeek: null,
		};
	},
	created() {
		//this.days = UtilityMixin.methods.getDaysOfWeekArray();

		this.daysWeekOptions = this.getDaysOfWeekArray();
		this.daysWeekOptions.unshift({ code: null, day: "-Seleziona Giorno-" });
	},
	mounted() {
		this.$emit("afterMounted");
	},
	computed: {
		dates() {
			return this.days.map((day) => day.date);
		},
		attributes() {
			return this.dates.map((date) => ({
				highlight: true,
				dates: date,
			}));
		},
	},
	watch: {
		tipologia(value) {
			this.pianificazione.params.tipologia = value;
			this.sltGiornoMese = value !== "GiornoMese";
			if (value === "GiornoMese") {
				this.hoursSelected = [];
				this.giorniSelezionati = null;
				this.pianificazione.giorni = "";
			}
			if (value == "DataMese") {
				this.dayWeek = null;
				this.frequenzaDayWeek = null;
			}

			this.aggiornaOrari();
		},
		jsonDataSchedulazione: {
			handler() {
				this.aggiornaOrari();
			},
			deep: true,
		},
		frequenzaDayWeek(value) {
			this.pianificazione.params.frequenza = value;
			this.aggiornaOrari();
			this.$emit("updatePianificazioneGiorniMese", this.pianificazione);
		},
		daysSelected() {
			let me = this;
			// if (me.frequenzaDayWeek != null && me.dayWeek != null) {
			// 	console.log(me.frequenzaDayWeek);
			// 	console.log(me.dayWeek);
			// }
			me.pianificazione.giorni = me.daysSelected ? me.daysSelected.join(",") : "";
			me.giorniSelezionati = me.pianificazione.giorni;
			this.$emit("updatePianificazioneGiorniMese", me.pianificazione);
			if (me.daysSelected.length > 0) {
				me.orarioDisabled = false;
				me.btnDisabledAggiungiOrario = false;
			} else {
				me.hoursSelected = [];
				me.orarioDisabled = true;
				me.btnDisabledAggiungiOrario = true;
			}
		},
		hoursSelected: function () {
			let me = this;
			me.pianificazione.orari = me.hoursSelected != "" ? me.hoursSelected.join(",") : "";
			this.$emit("updatePianificazioneGiorniMese", this.pianificazione);
		},
		giorniSelezionati() {
			this.$emit("updatePianificazioneGiorniMese", this.pianificazione);
			this.aggiornaOrari();
		},
		orarioRiferimento(value) {
			this.hoursSelected = [];
			this.hoursSelected.push(this.formatTime(value));
			this.aggiornaOrari();
			this.$emit("updatePianificazioneGiorniMese", this.pianificazione);
		},
	},
	methods: {
		init(jsonData) {
			let me = this;
			me.jsonDataSchedulazione = jsonData;
		},
		getClass(index) {
			if (index % 2 === 0) {
				return "sa-utility-alternate-even";
			} else {
				return "sa-utility-alternate-odd";
			}
		},
		aggiornaOrari() {
			let me = this;
			if (me.hoursSelected.length > 0) {
				switch (this.tipologia) {
					case "DataMese":
						this.aggiornaOraruDataMese();
						break;
					case "GiornoMese":
						this.aggiornaOraruGiornoMese();
						break;
				}
			}
		},
		aggiornaOraruGiornoMese() {
			this.elencoAttivitaProgrammate = [];
			let today = new Date();
			let year = today.getFullYear();
			let month = today.getMonth();
			let date = new Date(year, month, 1);
			let count = 0;
			let anno = year;

			if (this.dayWeek && this.frequenzaDayWeek) {
				while (count < 10) {
					let dayOfWeek = date.getDate() + 7 * (this.frequenzaDayWeek - 1);
					let mese = month + count;

					if (mese > 11) {
						mese = mese - 12;
						if (anno === year) {
							anno++;
						}
					}
					date = new Date(anno, mese, 1);

					let selectedDate = date;

					if (date.getDay() == this.dayWeek - 1) {
						dayOfWeek = date.getDate() + 7 * (this.frequenzaDayWeek - 1);
						selectedDate = new Date(date.getFullYear(), date.getMonth(), dayOfWeek);
					}
					while (date.getDay() != this.dayWeek - 1) {
						date.setDate(date.getDate() + 1);
						if (date.getDay() == this.dayWeek - 1) {
							dayOfWeek = date.getDate() + 7 * (this.frequenzaDayWeek - 1);
							selectedDate = new Date(date.getFullYear(), date.getMonth(), dayOfWeek);
						}
					}
					//console.log(this.frequenzaDayWeek);

					if (date >= new Date()) {
						if (this.hoursSelected.length > 0) {
							for (let orario of this.hoursSelected) {
								let split = orario.split(":");
								let hours = split[0];
								let minutes = split[1];
								selectedDate.setHours(hours);
								selectedDate.setMinutes(minutes);
								this.elencoAttivitaProgrammate.push(this.formatDateTimeCustom(selectedDate, "dddd DD MMMM YYYY HH:mm"));
							}
						}
					}

					count++;
				}
				this.numeroElencoProgrammatoLbl = this.elencoAttivitaProgrammate.length;
			}
		},
		aggiornaOraruDataMese() {
			let me = this;
			me.elencoAttivitaProgrammate = [];
			if (me.pianificazione.giorni && this.hoursSelected.length > 0) {
				let dataRiferimento = new Date();
				let giorni = me.pianificazione.giorni.split(",");
				let mese = dataRiferimento.getMonth();
				me.numeroElencoProgrammatoLbl = me.numeroElencoProgrammato * giorni.length;
				for (let orario of me.hoursSelected) {
					let split = orario.split(":");
					let ora = split[0];
					let minutes = split[1];
					for (let x = 0; x < me.numeroElencoProgrammato; x++) {
						for (let giorno of giorni) {
							dataRiferimento.setDate(giorno);
							dataRiferimento.setMonth(mese);
							dataRiferimento.setHours(ora);
							dataRiferimento.setMinutes(minutes);
							me.elencoAttivitaProgrammate.push(me.formatDateTimeCustom(dataRiferimento, "dddd DD MMMM YYYY HH:mm"));
						}
						mese++;
					}
				}
			}
		},
		disbilitaOrePrecedenti(date) {
			let me = this;
			let today = new Date();
			let dataRiferimento = new Date(me.pianificazione.dataInizio);
			if (dataRiferimento.getFullYear() === today.getFullYear() && dataRiferimento.getMonth() === today.getMonth() && dataRiferimento.getDate() === today.getDate()) {
				return date.getHours() < new Date().getHours();
			} else {
				return false;
			}
		},
		setPianificazione(pianificazione) {
			let me = this;
			me.pianificazione.giorni = pianificazione.giorni;
			me.pianificazione.orari = pianificazione.orari;
			me.pianificazione.tipo = pianificazione.tipo;
			me.pianificazione.params = JSON.parse(pianificazione.params);
			//me.pianificazione.params = JSON.parse(me.pianificazione.params);
			me.daysSelected = pianificazione.giorni ? pianificazione.giorni.split(",") : [];
			me.hoursSelected = pianificazione.orari ? pianificazione.orari.split(",") : [];
			me.numeroGiorni = me.pianificazione.giorni;

			if (me.pianificazione.params.tipologia === "GiornoMese") {
				this.dayWeek = pianificazione.giorni;
				this.frequenzaDayWeek = this.pianificazione.params.frequenza;
			}
			me.tipologia = me.pianificazione.params.tipologia;
			if (me.pianificazione.orari) {
				me.orarioRiferimento = me.parseFormatDateTime(me.pianificazione.orari, "HH:mm").getTime();
			}
		},
		onInputDaysAll(value) {
			let me = this;
			me.daysSelected = [];
			if (value) {
				this.days.forEach((element) => {
					me.daysSelected.push(element.code);
				});
			}
		},
		onClickRemoveOrario(index) {
			let me = this;
			me.hoursSelected.splice(index, 1);
			this.$emit("updatePianificazioneGiorniMese", me.pianificazione);
		},
		onClickAggiungiOrario() {
			let me = this;

			if (this.oraSelezionata) {
				me.hoursSelected.push(me.formatTime(this.oraSelezionata));
				me.hoursSelected = [...new Set(me.hoursSelected)];
				me.hoursSelected.sort();
			}
			this.$emit("updatePianificazioneGiorniMese", me.pianificazione);
			me.aggiornaOrari();
		},
		onContextCalendar(ctx) {
			//ctx.activeDate.getTime();
			let me = this;
			let giorno = me.formatDateTimeCustom(ctx.activeDate, "D");

			if (me.daysSelected.includes(giorno)) {
				me.daysSelected.splice(me.daysSelected.indexOf(giorno), 1);
			} else {
				me.daysSelected.push(giorno);
			}

			me.daysSelected = [...new Set(me.daysSelected)];
			me.daysSelected.sort((a, b) => {
				return a - b;
			});
			//console.log(me.formatDateTimeCustom(ctx.activeDate, "D"));
		},
		onDayClick(day) {
			// console.log(day);
			// console.log(day.id);
			// console.log(day.date);
			let giorni = [];
			const idx = this.days.findIndex((d) => d.id === day.id);
			if (idx >= 0) {
				this.days.splice(idx, 1);
			} else {
				this.days.push({ id: day.id, date: day.date });
			}
			this.days.sort((a, b) => {
				return a.date.getTime() - b.date.getTime();
			});
			this.days.forEach((day) => {
				let giorno = this.formatDateTimeCustom(day.date, "D");
				giorni.push(giorno);
			});
			this.daysSelected = [...new Set(giorni)];
			// console.log(this.daysSelected.length);
			// console.log(this.orarioRiferimento);
			if (this.daysSelected.length === 0) {
				//me.elencoAttivitaProgrammate = [];
				this.hoursSelected = [];
				this.orarioRiferimento = null;
				this.pianificazione.giorni = "";
			}
			//this.giorniSelezionati = giorni.join(",");
		},
		onInputFrequenzaDayWeek(value) {
			this.pianificazione.params.frequenza = value;
			//this.setGiornoMese();
			this.aggiornaOrari();
		},
		onInputDayWeek(value) {
			this.daysSelected = [];
			this.daysSelected.push(value);
		},
		setGiornoMese() {
			let me = this;
			me.pianificazione.params.frequenzaDayWeek = me.frequenzaDayWeek;
			me.pianificazione.params.dayWeek = me.dayWeek;
			if (me.frequenzaDayWeek != null && me.dayWeek != null) {
				this.$emit("updatePianificazioneGiorniMese", me.pianificazione);
			}
		},
	},
};
</script>

<style></style>
